import React, {useEffect, useState} from "react";
import {Typography} from "@mui/material";
import {formatCurrencyValue, getPricePerDayFromMonthlyRate} from "../../../../util/PaymentUtils";
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import {styled} from "@mui/material/styles";
import {LocationEquipmentType} from "../../../../types/Location";

const EquipmentTypePrice = styled(Typography)(() => ({
    textAlign: 'left',
}));

const EquipmentTypeSubprice = styled(Typography)(() => ({
    textAlign: 'left',
    '@media (max-width: 39.28em)': {
        fontSize: '0.8rem',
    }
}));

interface EquipmentTypeItemProps {
    asset: LocationEquipmentType;
    defaultPricePerDay: number;
    defaultPricePerMonth: number;
}

const EquipmentTypeItem = (props: EquipmentTypeItemProps) => {
    const {asset, defaultPricePerDay, defaultPricePerMonth} = props;

    const [pricePerDayInDollars, setPricePerDayInDollars] = useState<string | number | undefined>();
    const [pricePerMonthInDollars, setPricePerMonthInDollars] = useState<string | number | undefined>(defaultPricePerMonth);
    const [pricePerDayPerMonth, setPricePerDayPerMonth] = useState<string | number | undefined>();

    const {equipmentType, pricePerDay, pricePerMonth} = asset;

    useEffect(() => {
        const dailyPriceInCents = pricePerDay !== null && pricePerDay > 0 ? pricePerDay : defaultPricePerDay;
        const monthlyPriceInCents = pricePerMonth !== null && pricePerMonth > 0 ? pricePerMonth : defaultPricePerMonth;
        setPricePerDayInDollars(formatCurrencyValue(dailyPriceInCents));
        setPricePerMonthInDollars(formatCurrencyValue(monthlyPriceInCents));

        const pricePerDayBasedOnMonthInCents = getPricePerDayFromMonthlyRate(monthlyPriceInCents).amount;
        const pricePerDayBasedOnMonthInDollars = formatCurrencyValue(pricePerDayBasedOnMonthInCents);

        setPricePerDayPerMonth(pricePerDayBasedOnMonthInDollars)

    }, [pricePerDay, pricePerMonth, defaultPricePerDay, defaultPricePerMonth])

    return(
        <div className="ss-location-profile-pricing-grid-item">
            <div className="ss-location-profile-pricing-type-icon-container">
                <TrackChangesIcon className="ss-location-profile-pricing-icon"/>
                <Typography variant='body1' className="ss-location-profile-pricing-row-title">
                    {equipmentType}
                </Typography>
            </div>
            <div className="ss-location-profile-pricing-subcontainer-item">
                <EquipmentTypePrice variant='body1'>
                    {pricePerDayInDollars}
                </EquipmentTypePrice>
            </div>
            <div className="ss-location-profile-pricing-subcontainer-item">
                <EquipmentTypePrice variant='body1'>
                    {pricePerMonthInDollars}
                </EquipmentTypePrice>
                <EquipmentTypeSubprice variant='body1'>
                    ({pricePerDayPerMonth}/day)
                </EquipmentTypeSubprice>
            </div>
        </div>
    )
}

export default EquipmentTypeItem;
